export default __webpack_public_path__ + "static/media/interaction03.7a75ded4.png";